import React from "react";

const Onboard = React.lazy(() => import("pages/Onboard"));
const Login = React.lazy(() => import("pages/auth/Login"));
const Signup = React.lazy(() => import("pages/auth/Signup"));
const Otp = React.lazy(() => import("pages/auth/Otp"));
const ForgotPassword = React.lazy(() => import("pages/auth/ForgotPassword"));
const ResetPassword = React.lazy(() => import("pages/auth/ResetPassword"))
const ChangePassword = React.lazy(() => import("pages/ChangePassword"));

const PrevEnteries = React.lazy(() => import("pages/PreviousEnteries"));
const ShortlistedEnteries = React.lazy(
  () => import("pages/ShortlistedEnteries")
);
const CreateEntry = React.lazy(() => import("pages/CreateEntry"));
const EnteriesForm = React.lazy(() => import("pages/EnteriesForm"));
const Entries = React.lazy(() => import("pages/Entries"));
const Homepage = React.lazy(() => import("pages/Homepage"));
const EntryCategory = React.lazy(() => import("pages/EntryCategory"));
const Profile = React.lazy(() => import("pages/Profile"));
const EditProfile = React.lazy(() => import("pages/EditProfile"));
const EntryScoring = React.lazy(() => import("pages/EntryScoring"));
const Preview = React.lazy(() => import("pages/Preview"));
const MyDoc = React.lazy(() => import("pages/mydoc"));
const TermCondition = React.lazy(() => import("pages/entries/termCondition"));
const PreviewProfile = React.lazy(() => import("pages/previewProfile"));

export const onboardRoute = [
  { path: "/", exact: true, name: "Onboard", component: Onboard },
  { path: "/login", exact: true, name: "login", component: Login },
  { path: "/signup", exact: true, name: "signup", component: Signup },
  { path: "/verify", exact: true, name: "verify", component: Otp },
  {
    path: "/forgotPassword",
    exact: true,
    // name: "login",
    name: "forgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/resetPassword",
    exact: true,
    // name: "login",
    name: "resetPassword",
    component: ResetPassword,
  },
];

export const commonRoute = [
  {
    path: "/changePassword",
    exact: true,
    name: "ChangePassword",
    component: ChangePassword,
  },
  { path: "/profile", exact: true, name: "Profile", component: Profile },
  {
    path: "/editProfile",
    exact: true,
    name: "EditProfile",
    component: EditProfile,
  },
  { path: "/", exact: true, name: "EditProfile", component: EditProfile },
  {
    path: "/termCondition/:id",
    exact: true,
    name: "TermCondition",
    component: TermCondition,
  },
  { path: "/preview/:id", exact: true, name: "Preview", component: Preview },
];
export const userRoute = [
  {
    path: ["/User", "/home"],
    exact: true,
    name: "HomePage",
    component: Homepage,
  },
  {
    path: "/prevEnteries",
    exact: true,
    name: "PreviousEnteries",
    component: PrevEnteries,
  },
  { path: "/entry", exact: true, name: "Entry", component: CreateEntry },
  {
    path: "/entry/:id",
    exact: true,
    name: "Entry Questions",
    component: EnteriesForm,
  },
  {
    path: "/entryCategory",
    exact: true,
    name: "Entry Category",
    component: EntryCategory,
  },
];

export const judgeRoute = [
  {
    path: ["/Judge", "/home", "/enteries"],
    exact: true,
    name: "Entries",
    component: Entries,
  },
  {
    path: "/entryScoring/:id",
    exact: true,
    name: "EntryScoring",
    component: EntryScoring,
  },
  { path: "/preview/:id", exact: true, name: "Preview", component: Preview },
  {
    path: "/previewProfile/:id",
    exact: true,
    name: "Preview Profile",
    component: PreviewProfile,
  },
];

export const judgeChairPersonRoute = [
  {
    path: ["/JudgeChairPerson", "/home", "/shortlistedEnteries"],
    exact: true,
    name: "Entries",
    component: Entries,
  },
  { path: "/preview/:id", exact: true, name: "Preview", component: Preview },
];

export const partnerRoute = [
  {
    path: ["/Partner", "/home", "/enteries"],
    exact: true,
    name: "Entries",
    component: Entries,
  },
  {
    path: "/previewProfile/:id",
    exact: true,
    name: "Preview Profile",
    component: PreviewProfile,
  },
];

export default {
  onboardRoute,
  commonRoute,
  userRoute,
  judgeRoute,
  judgeChairPersonRoute,
  partnerRoute,
};
